import zxcvbn from 'zxcvbn'
import isBlank from 'is-blank'
import createFormModule from '../../utils/createFormModule'
import {
  NEW_PASSWORD_FORM_REQUEST,
  SET_TOKEN,
  SET_PASSWORD,
  SET_PASSWORD_CONFIRMATION
} from './types'

const formModule = createFormModule({
  resourcePath: '/password_resets/:token',
})

export const state = {
  ...formModule.state,
  request: {
    isLoading: false,
    error: null
  },
  form: {
    token: null,
    password: '',
    passwordConfirmation: ''
  }
}

const REQUIRED_FIELDS = ['token', 'password', 'passwordConfirmation']

export const mutations = {
  ...formModule.mutations,
  [NEW_PASSWORD_FORM_REQUEST] (state) {
    state.request.isLoading = true
  },
  [SET_TOKEN] (state, value) {
    state.form.token = value
  },
  [SET_PASSWORD] (state, value) {
    state.form.password = value
  },
  [SET_PASSWORD_CONFIRMATION] (state, value) {
    state.form.passwordConfirmation = value
  }
}

export const actions = {
  ...formModule.actions,
  setToken ({ commit }, value) {
    commit(SET_TOKEN  , value)
  },
  setPassword ({ commit }, value) {
    commit(SET_PASSWORD, value)
  },
  setPasswordConfirmation ({ commit }, value) {
    commit(SET_PASSWORD_CONFIRMATION, value)
  },
  customSubmit ({ commit, dispatch, state }) {
    commit(NEW_PASSWORD_FORM_REQUEST)
    const token = state.form.token
    const promise = dispatch('update', { token })
    return promise
  },
  reset ({ dispatch }) {
    dispatch('setToken', null)
    dispatch('setPassword', '')
    dispatch('setPasswordConfirmation', '')
  }
}

export const getters = {
  ...formModule.getters,
  isValid ({ form }) {
    const blankFields = REQUIRED_FIELDS.filter(field => isBlank(form[field]))
    return zxcvbn(form['password']).score === 4
            && blankFields.length <= 0
            && form['password'] == form['passwordConfirmation']
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/newPasswordForm.js